import { ConditionType, ConditionValueVersion } from "@gsp-wf/wf-process-model";
export class Condition {
    private _value;
    private valueVersion;
    private type;
    ConditionType: ConditionType;
    Value: string;
    ValueVersion: ConditionValueVersion;
    constructor() {

    }
}
